
import Vue from 'vue';
import Default from './layouts/Default.vue';
import Login from './layouts/Login.vue';
import Tracking from './layouts/Tracking.vue';
import {mapGetters,mapActions} from 'vuex';
import Final from "./layouts/Final.vue";
import L_QrLabel from "./layouts/L_QrLabel.vue";
import { EventBus } from './services/ToastService';

export default Vue.extend({
  name: 'App',

  components: {
    Default,
    Login,
    Tracking,
    Final,
    L_QrLabel
  },
  
  data: () => ({
    // Usar data para almacenar los métodos created originales
    _originalCreatedHooks: [] as Function[]
  }),
  
  beforeCreate() {
    this.$store.commit('login/LOAD_INIT_DATA');
    this.$i18n.locale = localStorage.getItem('locale') || 'pt-br';
  },
  
  computed: {
    ...mapGetters({
      layout: 'general/layout',
      isLoggedIn: 'login/isLoggedIn'
    }),
  },
  
  // Este created se ejecutará después de los otros hooks del ciclo de vida
  created() {
    // Configurar el listener para notificaciones desde servicios
    EventBus.$on('show-toast', (notification: any) => {
      if (!this.$toast) return;
      
      const { type, message, title, options } = notification;
      
      switch (type) {
        case 'success':
          this.$toast.success(message, title || 'Éxito', options);
          break;
        case 'error':
          this.$toast.error(message, title || 'Error', options);
          break;
        case 'info':
          this.$toast.info(message, title || 'Información', options);
          break;
        case 'warning':
          this.$toast.warning(message, title || 'Advertencia', options);
          break;
        default:
          this.$toast.info(message, title, options);
      }
    });
  },
  
  mounted() {
    // do something based on the navigation type...
    if(this.isLoggedIn){
      this.browserAction();
    }
  },
  
  beforeDestroy() {
    // Limpiar el listener para evitar fugas de memoria
    EventBus.$off('show-toast');
  },
  
  methods: {
    ...mapActions({
      getInitData: 'general/getInitData',
    }),
    browserAction() {
      // do something based on the navigation type...
      switch (window.performance.navigation.type) {
        case 0:
          console.info("TYPE_NAVIGATE");
          this.getInitData([this.$toast, true]);
          break;
        case 1:
          console.info("TYPE_RELOAD");
          this.getInitData([this.$toast, true]);
          break;
        case 2:
          console.info("TYPE_BACK_FORWARD");
          break;
        case 255:
          console.info("255");
          break;
      }
    },
  }
});
